import React from "react";
import { Link } from "react-router-dom";
import { GraduationCap, Mail, MapPin, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-primary text-primary-foreground" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <img src="/logo.jpg" alt="Sano Student Logo" className="h-12 bg-white rounded-md p-1 object-contain" />
            </div>
            <p className="text-sm text-primary-foreground/70 max-w-md leading-relaxed">
              Türkiye&apos;nin özel okul bursluluk başvuruları, deneme sınavları ve
              eğitim tercih danışmanlığı platformu. Öğrenciler, veliler ve
              okulları güvenli bir dijital ortamda buluşturuyoruz.
            </p>
          </div>
          <div>
            <div className="overline text-primary-foreground/60 mb-4">Öğrenciler</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/okullar" className="hover:text-accent">Okulları Keşfet</Link></li>
              <li><Link to="/bursluluk-sinavlari" className="hover:text-accent">Bursluluk Sınavları</Link></li>
              <li><Link to="/deneme-sinavlari" className="hover:text-accent">Deneme Sınavları</Link></li>
              <li><Link to="/cikmis-sorular" className="hover:text-accent">Çıkmış Sorular</Link></li>
              <li><Link to="/tercih-danismanligi" className="hover:text-accent">Tercih Danışmanlığı</Link></li>
            </ul>
          </div>
          <div>
            <div className="overline text-primary-foreground/60 mb-4">Kurumsal</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/nasil-calisir" className="hover:text-accent">Nasıl Çalışır</Link></li>
              <li><Link to="/hakkimizda" className="hover:text-accent">Hakkımızda</Link></li>
              <li><Link to="/okullar-icin" className="hover:text-accent">Okullar İçin</Link></li>
              <li><Link to="/okul-kayit" className="hover:text-accent font-semibold">➕ Okul Ekle</Link></li>
              <li><Link to="/paketler" className="hover:text-accent">Paketler</Link></li>
              <li><Link to="/sss" className="hover:text-accent">SSS</Link></li>
              <li><Link to="/iletisim" className="hover:text-accent">İletişim</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-primary-foreground/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-primary-foreground/60">
          <div>© 2026 SanoStudent — Bursluluk Sınavı ve Eğitim Tercih Platformu.</div>
          <div className="flex items-center gap-4 flex-wrap">
            <span className="inline-flex items-center gap-1.5"><Mail className="h-3 w-3" /> destek@sanostudent.com</span>
            <span className="inline-flex items-center gap-1.5"><Phone className="h-3 w-3" /> 0850 000 00 00</span>
          </div>
        </div>
        <div className="mt-4 pt-4 border-t border-primary-foreground/10 flex flex-wrap gap-x-4 gap-y-1 text-[11px] text-primary-foreground/50">
          <Link to="/kvkk-aydinlatma-metni" className="hover:text-accent">KVKK Aydınlatma</Link>
          <Link to="/gizlilik-politikasi" className="hover:text-accent">Gizlilik Politikası</Link>
          <Link to="/cerez-politikasi" className="hover:text-accent">Çerez Politikası</Link>
          <Link to="/kullanim-sozlesmesi" className="hover:text-accent">Kullanım Sözleşmesi</Link>
          <Link to="/mesafeli-satis-sozlesmesi" className="hover:text-accent">Mesafeli Satış</Link>
          <Link to="/iade-iptal" className="hover:text-accent">İade & İptal</Link>
          <Link to="/ticari-elektronik-ileti" className="hover:text-accent">Ticari İleti</Link>
          <Link to="/erisilebilirlik" className="hover:text-accent">Erişilebilirlik</Link>
        </div>
      </div>
    </footer>
  );
}
